import Vue from 'vue'
import Vuex from 'vuex'

// Modules

import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import farm from './farm'
import user from './user'
import animal from './animal'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    state:{
      config:{},
    },

    mutations: {
      setConfig: ({state, token}) =>{
        state.config = { headers: {"X-Authorization": `Bearer ${token}`} }
      },
    },
    actions: {
      async AddConfig({commit}, token) {
        commit("setConfig", localStorage.getItem("token")) 
      }
    },
    app,
    appConfig,
    verticalMenu,
    farm,
    user,
    animal,
  },
  strict: process.env.DEV,
})
